import type { DropperFunnelStatsResponse } from '@/entities/dropper-funnel';
import { api } from './http';

export async function fetchDropperFunnelStats(buildId: string, period: '7d' | '30d' = '7d'): Promise<DropperFunnelStatsResponse> {
	const { data } = await api.get<DropperFunnelStatsResponse>('/panel/dropper-funnel/stats', {
		params: { buildId, period },
	});
	return data;
}
